import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const StatisticsSkeleton = () => (
  <Styles.Container>
    <Styles.Column>
      {Array.from({ length: 7 }).map((_, index) => (
        <Skeleton key={index} variant="rounded" width="100%" height={80} />
      ))}
    </Styles.Column>
    <Styles.Column>
      <Skeleton variant="rounded" width="100%" height={80} />
      <Skeleton variant="rounded" width="100%" height={250} />
      <Skeleton variant="rounded" width="100%" height={160} />
    </Styles.Column>
  </Styles.Container>
)

export default StatisticsSkeleton
